export const getBarcodes = (lineItems = []) => {
  const barcodes = lineItems?.flatMap(({ partName, serialization }) =>
    serialization.map((barcode) => ({
      barcode,
      partName,
    })),
  );

  const chunkSize = 64;
  const barcodeChunks = [];

  for (let i = 0; i < barcodes.length; i += chunkSize) {
    barcodeChunks.push(barcodes.slice(i, i + chunkSize));
  }
  return barcodeChunks;
};
